import { render, staticRenderFns } from "./PopupCommon.vue?vue&type=template&id=58d327ba&scoped=true"
import script from "./PopupCommon.vue?vue&type=script&lang=js"
export * from "./PopupCommon.vue?vue&type=script&lang=js"
import style0 from "./PopupCommon.vue?vue&type=style&index=0&id=58d327ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d327ba",
  null
  
)

export default component.exports